import { Button, useOrganisationFollow } from '@yeshuman/sdk'
import { Loader2, Minus, Plus } from 'lucide-react'


type CandidateOrganisationFollowButtonProps = {
  slug: string
}

export function CandidateOrganisationFollowButton({ slug }: CandidateOrganisationFollowButtonProps) {
  const { following, isLoading, isPending, toggleFollow } = useOrganisationFollow(slug)

  const label = following ? 'Unfollow' : 'Follow'

  return (
    <Button
      type="button"
      variant="outlinePrimary"
      size="sm"
      disabled={isLoading || isPending}
      aria-pressed={following}
      aria-label={label}
      onClick={toggleFollow}
    >
      {isPending ? (
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
      ) : following ? (
        <Minus className="h-4 w-4" aria-hidden />
      ) : (
        <Plus className="h-4 w-4" aria-hidden />
      )}
      {label}
    </Button>
  )
}
